<template>
    <div class="NoteWrite">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>쪽지 쓰기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title">
                <div class="inline-block mrg-right-10">받는 사람</div>
                <h2 class="inline-block color-black"><strong> {{ strNickName }} </strong> ({{ strUserId | idHidden }})</h2>
            </h2>
            <h2 class="slidePanel-title">
                <div class="inline-block mrg-right-10">
                    <div class="checkbox-list">
                        <span>
                            <label class="ckb square color-black"><input type="checkbox" v-model="cSendNoteSave"  /><i></i> 보낸 쪽지함에 저장</label>
                        </span>
                    </div>
                </div>
                <h2 class="inline-block pull-right"><span>{{ strMessage.length }}/{{ maxMessage }}자</span></h2>
            </h2>
            <div class="note-content">
                <!-- @keyup="maxLengthCheck" -->
                <textarea placeholder="쪽지를 입력해 주세요." v-model="strMessage" :maxlength="maxMessage" ref="strMessage" />
            </div>
            <footer class="flex justify-between">
                <button class="btn-big btn-bule" @click="messageSendActionFunc">보내기</button>
            </footer>
        </div>
    </div>
</template>

<script>

export default {
    name: 'NoteWrite',
    props: ['pNoteTab','pIdx'],
    data() {
        return {
            strMessage:'',              // 받은,보낸 쪽지 내용
            strUserId:'',               // 받은,보낸 아이디
            strNickName:'',             // 받은,보낸 닉네임
            strRegDate:'',              // 받은,보낸 일자
            maxMessage:1000,            // 최대 글자수
            cSendNoteSave : true,
        }
    },
    filters: {
        // 일부 아이디 히든처리
        idHidden:function (str){
            return str.substring(0,str.length-3)+'***';
        }
    },
    // 감시자
    watch: {
    },
    // 계산된 속성
    computed:{
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getMessageReplyFunc();
    },
    methods: {
        // maxLengthCheck(){
        //     if (this.strMessage.length > this.maxMessage){
        //         this.strMessage = this.strMessage.slice(0, this.maxMessage);
        //     }
        // },
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 받은 쪽지, 보낸쪽지 상세
        getMessageReplyFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/message/'+this.pNoteTab+'/reply/'+this.pIdx, param,this.getMessageReplyFuncResult);
        },
        // 받은 쪽지, 보낸쪽지 상세 결과
        getMessageReplyFuncResult(response){
            if (response.result.code == 0){
                this.strMessage = response.oMessageInfo.detail.strMessage;
                if (this.pNoteTab == 'receive'){
                    this.strUserId = response.oMessageInfo.detail.strSendUserId;
                    this.strNickName = response.oMessageInfo.detail.strSendNickName;
                }else{
                    this.strUserId = response.oMessageInfo.detail.strReceiveUserId;
                    this.strNickName = response.oMessageInfo.detail.strReceiveNickName;
                }

                this.strRegDate = response.oMessageInfo.detail.strRegDate;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 받은 쪽지, 보낸쪽지 보내기
        messageSendActionFunc(){
            let formData = new FormData();
            formData.append('strReceiveUserId', this.strUserId);
            formData.append('strContent', this.strMessage);
            formData.append('cSendNoteSave', this.cSendNoteSave ? 'Y' : 'N');

            if (this.pNoteTab == 'receive'){
                formData.append('nReplyNum', this.pIdx);
            }
            this.ajaxPostAuth('/api/v1/message/send/action', formData,this.messageSendActionFuncResult);

        },
        // 받은 쪽지, 보낸쪽지 보내기 결과
        messageSendActionFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.slidePanelClose('sendReload');
            }else{
                if (result.resultNoti.type == 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
    }
}
</script>

<style scoped>
    .inline-block {display: inline-block !important;}
    .slidePanel-title { font-size: 14px; color: #bdbdbd; font-weight: 300}
    .slidePanel-title h2{ font-weight: 500;}
    .note-content {font-size: 16px; padding-top: 15px;margin-bottom: 120px;}
    footer {position: fixed !important; bottom: 0px;left: 0;right: 0;border-top: 1px solid #dfdfdf;padding: 20px 10px; background: #fff}
    textarea { width: 100%;font-size: 14px; min-height: 300px; border: 1px solid #dfdfdf; }
</style>
